module.exports = __webpack_public_path__ + "img/corner-settings-lg.8208a335.svg";